/** Match backend withdrawal_tds: 5% on total gross, ROUND_HALF_UP to paise. */

export const TDS_PERCENT = 5;

function toNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

/** ROUND_HALF_UP to 2 decimal places (paise). */
export function quantizeMoney(value) {
  const n = toNumber(value);
  const sign = n < 0 ? -1 : 1;
  const abs = Math.abs(n);
  return (sign * Math.round(abs * 100 + Number.EPSILON)) / 100;
}

/**
 * TDS for one payment: 5% of gross total (sum months first, then TDS once).
 * Example: 100+100+150 → gross 350 → TDS 17.50 → net 332.50
 */
export function computeTdsBreakdown(gross) {
  const g = quantizeMoney(Math.max(0, toNumber(gross)));
  const tds = quantizeMoney(g * (TDS_PERCENT / 100));
  const net = quantizeMoney(g - tds);
  return { gross: g, tds, net, percent: TDS_PERCENT };
}

export function computeTdsOnGrossList(grossAmounts) {
  const total = (grossAmounts || []).reduce((sum, g) => sum + toNumber(g), 0);
  return computeTdsBreakdown(total);
}

export function cycleGross(row) {
  return toNumber(row?.gross_amount ?? row?.earned_points ?? row?.amount ?? 0);
}

export function formatInr(value) {
  return quantizeMoney(value).toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
